export default "__VITE_ASSET__96e01a87__"